import { Case } from '@debbie/common/dist/cases/index.js'
import { CaseVoucher } from '@debbie/common/dist/economy/case-vouchers/index.js'
import { Plan } from '@debbie/common/dist/economy/payment-plans/index.js'
import { UserRole } from '@debbie/common/dist/users/roles.js'
import React from 'react'

import CongratulationsStep from './CongratulationsStep.js'
import ConnectCardStep from './ConnectCardStep.js'
import GatherInfoStep from './GatherInfoStep.js'
import SelectPlanStep from './SelectPlanStep.js'
import SigningStep from './SigningStep.js'

export enum Steps {
  SELECTPLAN = 'SELECTPLAN',
  GATHERINFO = 'GATHERINFO',
  SIGNING = 'SIGNING',
  CONNECTCARD = 'CONNECTCARD',
  CONGRATULATIONS = 'CONGRATULATIONS',
}

interface Props {
  singleCase: Case
  paymentPlan: Plan | null
  caseVouchers: CaseVoucher[]
  meRole: UserRole
  step: Steps
  onSkipGatherInfo?: () => void
}

const Step = ({
  singleCase,
  caseVouchers,
  meRole,
  step,
  paymentPlan,
  onSkipGatherInfo,
}: Props) => {
  switch (step) {
    case Steps.SELECTPLAN:
      return (
        <SelectPlanStep
          caseId={singleCase.caseId}
          caseVouchers={caseVouchers}
          currency={singleCase.currency}
        />
      )
    case Steps.GATHERINFO:
      return (
        <GatherInfoStep
          singleCase={singleCase}
          onSkip={onSkipGatherInfo ?? (() => {})}
        />
      )
    case Steps.SIGNING:
      if (paymentPlan == null) {
        return null
      }
      return (
        <SigningStep
          meRole={meRole}
          paymentPlan={paymentPlan}
          singleCase={singleCase}
        />
      )

    case Steps.CONNECTCARD:
      if (paymentPlan == null) {
        return null
      }
      return (
        <ConnectCardStep paymentPlan={paymentPlan} singleCase={singleCase} />
      )
    case Steps.CONGRATULATIONS:
      if (paymentPlan == null) {
        return null
      }
      return (
        <CongratulationsStep
          currency={singleCase.currency}
          caseId={singleCase.caseId}
          paymentPlan={paymentPlan}
        />
      )
  }
}

export default Step
